import Layout from '@/components/layout/Index';

const Support = () => {
	return (
		<div className='flex flex-col w-full overflow-hidden'>
			<Layout>
				<main className='w-full h-screen'>
					<div>Support</div>
				</main>
			</Layout>
		</div>
	);
};

export default Support;
